import i18next from 'i18next';

import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import fr from './fr.json';
import pt from './pt.json';
import it from "./it.json";
import nl from "./nl.json";
import es from "./es.json";
import fi from "./fi.json";
import cs from "./cs.json";
import vi from "./vi.json";
export const LOCALE_NAME_MAP = [
  ["en", "English"],
  ["fr", "Français"],
  ["nl", "Nederlands"],
  ["es", "Español"],
  ["pt", "Português"],
  ["it", "Italiano"],
  ["fi", "Suomi"],
  ["cs", "Čeština"],
  ["vi", "Tiếng Việt"],
] as [string, string][];

// Returns current language code. E.g. 'en'
export function getCurrentLanguage(): string {
  return i18next.language;
}

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
    nsSeparator: ".";
    contextSeparator: "?";
    // resources: typeof en.en;
  }
}

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'en',
    supportedLngs: [
      "en",
      "fr",
      "pt",
      "it",
      "nl",
      "es",
      "fi",
      "cs",
      "vi",
    ],
    returnNull: false,
    contextSeparator: "?",
    postProcess: false,
    resources: {
      ...en,
      ...fr,
      ...pt,
      ...it,
      ...nl,
      ...es,
      ...fi,
      ...cs,
      ...vi,
    },
    detection: {
      order: ["cookie"],
      lookupCookie: "preferred_language"
    },
    interpolation: {
      prefix: "%{",
      suffix: "}",
      escapeValue: false,
    },
    // Enable debug
    // debug: true
  });
